import React, { useEffect, useRef } from "react";
import s from './MyPopModal.module.css';

export function MyPopModal({showPop, setShowPop, mainMessage : MainMsg, data}) {
	
	if(!showPop) {
		return (<div></div>)
	}
	
	return (<div>
		<div className={s.popupmodel_holder}>
			<MainMsg data={data}/>
		</div>
	
		<div className={s.modalBackdrop} onClick={()=>setShowPop(false)}/>
	</div>)
}

